export const USER_OPS_EMPTY_KEYS = {
  userOps: 'userOps.empty.userOps',
} as const;

export const USER_OPS_FIELD_KEYS = {
  userOpHash: 'userOps.fields.userOpHash',
  bundleTxHash: 'userOps.fields.bundleTxHash',
  age: 'userOps.fields.age',
  status: 'userOps.fields.status',
  sender: 'userOps.fields.sender',
  bundler: 'userOps.fields.bundler',
  entryPoint: 'userOps.fields.entryPoint',
  txHash: 'userOps.fields.txHash',
  block: 'userOps.fields.block',
  totalOps: 'userOps.fields.totalOps',
  fee: 'userOps.fields.fee',
  feeWithSymbol: 'userOps.fields.feeWithSymbol',
} as const;
